import React, { useState } from "react";
import { Modal, Input } from "antd";
import ReactGA from "react-ga4";
import { constructAddress } from "./utils/constructAddress";



export const AddMessageModal = ({
  visible,
  handleBackToChooseAddressModal,
  handleCloseAllModals,
  selectedAddress,
  textFormSubmit
}) => {
  const [additionalMessage, setAdditionalMessage] = useState("")


  const handleOkClick = () => {

    ReactGA.event({
      category: "Inbox",
      action: "Click",
      label: "Poslana adresa"
    });


    const newMessage =
      `Korisnik je poslao podatke za slanje:\n
      ${selectedAddress.fullName}
${selectedAddress.vatInvoiceLegalEntityName ? `${selectedAddress.vatInvoiceLegalEntityName}` : ""}\n
${selectedAddress.street} ${selectedAddress.houseNumber ? selectedAddress.houseNumber : ""} ${selectedAddress.zipCode && `, ${selectedAddress.zipCode}`}
${constructAddress(selectedAddress)}\n
Kontakt telefon: ${selectedAddress.phoneNumber}\n
${additionalMessage ? `Dodatna poruka:
  ${additionalMessage}` : ""}`

    textFormSubmit({
      customMessage: newMessage
    })

    handleCloseAllModals()

  }


  return (<Modal
    visible={visible}
    onCancel={handleBackToChooseAddressModal}
    title="Slanje adrese"
    onOk={handleOkClick}
    okText="Pošalji adresu"
    cancelText="Natrag"
    centered
    bodyStyle={{ maxHeight: "calc(100dvh - 200px)", overflowY: "auto" }}
  >
    <div>
      <p style={{ fontWeight: 600 }}>{selectedAddress.fullName}</p>
      {selectedAddress.vatInvoiceLegalEntityName && <p>{selectedAddress.vatInvoiceLegalEntityName}</p>}
      <p>{`${selectedAddress.street} ${selectedAddress.houseNumber ? selectedAddress.houseNumber : ""} ${selectedAddress.zipCode && `, ${selectedAddress.zipCode}`}`}</p>
      <p>{constructAddress(selectedAddress)}</p>
      <p>{selectedAddress.phoneNumber}</p>
      <div style={{ marginTop: 12 }}>

        <span style={{ fontWeight: 600 }}>Dodatna poruka (neobavezno):</span>
        <Input.TextArea
          value={additionalMessage}
          onChange={(e) => setAdditionalMessage(e.target.value)}
          rows={3}
          style={{ marginTop: 6, fontWeight: "normal", height: 80 }}
        />
      </div>
    </div>
  </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/SendAddressModal/AddMessageModal.tsx